import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"
import { localeCode } from "./localeCodes"
export { browserLanguageId, languageId, localeCode, ogLocale } from "./localeCodes"
dayjs.extend(localizedFormat)
import "dayjs/locale/fr"
import "dayjs/locale/en"
import "dayjs/locale/he"
import "dayjs/locale/it"
import "dayjs/locale/pt"
import "dayjs/locale/ru"
import "dayjs/locale/de"
import "dayjs/locale/es"
import "dayjs/locale/el"
import "dayjs/locale/ro"

export function formatDayjs(value, lang, pattern) {
    return dayjs(value).locale(localeCode(lang)).format(pattern)
}

export function formatDate(value, lang, pattern) {
    return formatDayjs(value, lang, pattern)
}
